const FIELDS_SORT_OPTIONS = [
  {
    label: 'A-Z',
    value: 'attributes__name',
  },
  {
    label: 'Z-A',
    value: '-attributes__name',
  },
];

export default FIELDS_SORT_OPTIONS;
